import { render, staticRenderFns } from "./HPservices.vue?vue&type=template&id=2997b892&scoped=true&"
import script from "./HPservices.vue?vue&type=script&lang=js&"
export * from "./HPservices.vue?vue&type=script&lang=js&"
import style0 from "./HPservices.vue?vue&type=style&index=0&id=2997b892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2997b892",
  null
  
)

export default component.exports